
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-[75vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/26930ff0d82709b83a3957dc0536553c.jpg"
          alt="مركز التحكم الأمني المتقدم"
          className="w-full h-full object-cover object-center"
        />
        {/* Overlay قوي لوضوح النص */}
        <div className="absolute inset-0 bg-navy/80"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Text Content */}
          <div className="text-white">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/60 bg-primary/10 backdrop-blur-sm mb-6">
              <i className="ri-shield-star-line text-primary"></i>
              <span className="text-sm font-medium">الرائدون في الحلول الأمنية</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6 tracking-wide">
              حلول أمنية متكاملة
              <br />
              <span className="text-primary">لحماية منشآتك بثقة</span>
            </h1>

            {/* Description */}
            <p className="text-lg text-silver leading-relaxed mb-8 max-w-xl">
              نوفر أحدث أنظمة الأمان والمراقبة المتطورة لحماية منشآتك ومشاريعك الكبرى بأعلى معايير الجودة والاحترافية مع دعم فني متميز على مدار الساعة.
            </p>

            {/* Quick Features */}
            <div className="flex flex-wrap gap-4 mb-10">
              {[
                { icon: 'ri-award-line', text: '+15 عام خبرة' },
                { icon: 'ri-shield-check-line', text: 'جودة معتمدة' },
                { icon: 'ri-customer-service-2-line', text: 'دعم فني 24/7' },
                { icon: 'ri-building-line', text: 'مشاريع كبرى' },
              ].map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20"
                >
                  <i className={`${feature.icon} text-primary`}></i>
                  <span className="text-sm font-medium">{feature.text}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-5">
              <Link
                to="/contact"
                className="group px-8 py-4 bg-primary text-white text-base font-semibold rounded-lg hover:bg-primary-dark transition-all duration-300 flex items-center gap-2 shadow-lg hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
              >
                <span>اطلب عرض سعر</span>
                <i className="ri-arrow-left-line group-hover:-translate-x-1 transition-all duration-300"></i>
              </Link>
              <a
                href="tel:+966500000000"
                className="px-8 py-4 bg-transparent text-white text-base font-semibold rounded-lg border-2 border-white/60 hover:bg-white hover:text-navy transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                <span>تواصل معنا</span>
              </a>
            </div>
          </div>

          {/* Right Side - Visual Content */}
          <div className="hidden lg:block">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden border border-primary/30 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20security%20camera%20installation%20on%20modern%20building%20exterior%2C%20high-tech%20surveillance%20system%20with%20multiple%20cameras%2C%20sleek%20black%20security%20equipment%20mounted%20on%20contemporary%20architecture%2C%20professional%20installation%20work%2C%20clean%20corporate%20aesthetic%2C%20daytime%20photography%2C%20sharp%20focus%2C%20architectural%20photography%20style%2C%20premium%20quality%20security%20hardware&width=800&height=900&seq=hero-security-img-002&orientation=portrait"
                  alt="أنظمة الأمان المتطورة"
                  className="w-full h-[480px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/50 via-transparent to-transparent"></div>
              </div>

              {/* Floating Badge */}
              <div className="absolute top-8 right-8 bg-primary text-white px-6 py-4 rounded-2xl shadow-xl">
                <div className="text-3xl font-bold">+15</div>
                <div className="text-sm">عام خبرة</div>
              </div>

              {/* Floating Stats */}
              <div className="absolute bottom-8 left-8 bg-navy/90 backdrop-blur-sm border border-silver/20 text-white px-6 py-4 rounded-2xl shadow-xl">
                <div className="text-3xl font-bold text-primary">+500</div>
                <div className="text-sm text-silver">مشروع منجز</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-primary rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
